import { pickObjectUtil } from 'packages/src'

const SOCIAL_NAME = {
  ETSY: 'etsy',
  FACEBOOK: 'facebook',
  TUMBLR: 'tumblr',
  INSTAGRAM: 'instagram',
  X: 'x',
  YOUTUBE: 'youtube',
  GOOGLE: 'google',
  PINTEREST: 'pinterest',
  WEHEARTIT: 'weheartit'
}

const SOCIAL_MAIN = pickObjectUtil(
  SOCIAL_NAME,
  [
    'INSTAGRAM',
    'ETSY',
    'FACEBOOK',
    'X'
  ]
)
const SOCIAL_URL = {
  [SOCIAL_NAME.ETSY]: '//www.etsy.com/shop/GymaholicStore',
  [SOCIAL_NAME.FACEBOOK]: '//facebook.com/gymaholic',
  [SOCIAL_NAME.TUMBLR]: '//gymaaholic.tumblr.com',
  [SOCIAL_NAME.INSTAGRAM]: '//instagram.com/gymaholic',
  [SOCIAL_NAME.X]: '//twitter.com/gymaholic',
  [SOCIAL_NAME.YOUTUBE]: '//www.youtube.com/user/GymaholicSite',
  [SOCIAL_NAME.PINTEREST]: '//pinterest.com/gymaaholic',
  [SOCIAL_NAME.WEHEARTIT]: '//weheartit.com/gymaholic_site'
}

const SOCIAL_SHARE_URL = {
  [SOCIAL_NAME.FACEBOOK]: '//www.facebook.com/sharer/sharer.php?u=${0}', // eslint-disable-line
  [SOCIAL_NAME.X]: '//twitter.com/intent/tweet?url=${0}&text=${1}&hashtags=gymaholic&via=${2}', // eslint-disable-line
  [SOCIAL_NAME.PINTEREST]: '//pinterest.com/pin/create/button/?url=${0}&description=${1}&media=${2}' // eslint-disable-line
}

export const SOCIAL_AUTH_NAME = {
  [SOCIAL_NAME.FACEBOOK]: 'facebook', // eslint-disable-line
  [SOCIAL_NAME.X]: 'twitter', // eslint-disable-line
  [SOCIAL_NAME.GOOGLE]: 'google' // eslint-disable-line
}

const SOCIAL_REGEX = {
  SHARE: /[^$]+(\${.})/g
}

export {
  SOCIAL_NAME,
  SOCIAL_MAIN,
  SOCIAL_URL,
  SOCIAL_SHARE_URL,
  SOCIAL_REGEX
}
